
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, TableRow, TableCell, List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemIcon, Menu, MenuItem, IconButton } from '@mui/material';
import CustomListviewLoader from '../../../core/components/common/custom-listview-loader.component';
import CustomTable from '../../../core/components/common/custom-table.component';
import CustomChipComponent from '../../../core/components/common/custom-chip.component';
import moment from 'moment';
import theme from '../../../core/components/layout/theme';
import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DevicesIcon from '@mui/icons-material/Devices';
import UpdateUserProfileComponent from './update-user-profile.component';
import UpdateProfileStatus from './update-profile-status.component';
import UpdateProfileStatusComponent from './update-profile-status.component';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import UpdateIcon from '@mui/icons-material/Update';

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}`,
  };
}

const CustomMenuPopperComponent = (props) => {

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const profile_uid = rbacStorage?.state?.currentProfile?.profileId || null;


    const {data, setOpen, theme, customIconStyles, onAction, user_uid} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const navigate = useNavigate();

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleUpdateStatus = () => {
        setOpen(true);
    }

    console.log("Data in CustomMenuPopperComponent:", data, user_uid);

    const menuItems = [
        ...(data.profile_uid !== profile_uid ? [{
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Profile",
            onClick: () => navigate('/user/view/profile?profile_uid=' + data.profile_uid + "&user_uid=" + user_uid),
        }] : []),
        {
            icon: <PersonAddIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Update Profile",
            onClick: () => onAction("profile", data),
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Update Status",
            onClick: () => onAction("status", data),
        },
    ];


    return (
        <>
  
            {menuItems.length > 0 &&
                <>
                    <IconButton onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{style: {maxHeight: 300}}}
                    >
                        {menuItems?.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    handleClose();
                                    item.onClick();
                                }}
                                sx={{}}
                            >
                                <ListItemIcon sx={customIconStyles}>
                                    {item.icon}
                                </ListItemIcon>
                    
                                <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            }
        </>
    );
};

export default function UserProfileListComponent(props) {

    const {profileList, user_uid} = props;

    const [dialog, setDialog] = useState({ open: false, type: null, action: null });
    
    const openDialog = (type, action) => {
        setDialog({ open: true, type, action });
    };

    const closeDialog = () => {
        setDialog({ open: false, type: null, action: null });
    };

    const headers = [
        { label: "Profile" },
        { label: "ID Number" },
        { label: "ID Type" },
        { label: "Status" },
        { label: "Updated At" },
        { label: "Actions" },
    ]

    return (
        <Box>
            {/* {loading ?
                <CustomListviewLoader />
            : */}
                <CustomTable headers={headers}>
                    {
                        profileList?.length > 0 ? (
                            profileList?.map((row) => {

                                const formattedBirthdate = moment(row.birthdate).format("MMMM DD, YYYY");
                                const formattedLastModified = moment(row.updated_at).format("MMMM DD YYYY, h:mm:ss a");

                                return (
                                    <TableRow key={row.id}>
                                        <TableCell >
                                            <List >
                                                <ListItem>
                                                    <ListItemAvatar>
                                                        <Avatar {...stringAvatar(row.profile_type)} />
                                                    </ListItemAvatar>
                                                    <ListItemText primary={row.profile_type} secondary={row.role} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                       
                                        <TableCell>{row.id_no}</TableCell>
                                        <TableCell>{row.id_type}</TableCell>
                                        <TableCell>
                                            <CustomChipComponent category="userStatus"
                                            label={(row.status === "Active") ? "Active" 
                                                : 
                                                    (row.status === "Deactivated") ? "Deactivated"
                                                :
                                                    row.status
                                            }
                                            />
                                        </TableCell>
                                        <TableCell>
                                         {formattedLastModified}
                                        </TableCell>
                                        <TableCell>
                                            <CustomMenuPopperComponent
                                                data={row}
                                                onAction={openDialog}
                                                theme={theme}
                                                user_uid={user_uid}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers.length} align="center">
                                    No available account to display
                                </TableCell>
                            </TableRow>
                        )

                    }
                </CustomTable>

            {dialog.open && dialog.type === "profile" && (
                <UpdateUserProfileComponent
                    open={dialog.open}
                    setOpen={closeDialog}
                    selectedProfile={dialog.action}
                />
            )}

            {dialog.open && dialog.type === "status" && (
                <UpdateProfileStatusComponent
                    open={dialog.open}
                    setOpen={closeDialog}
                    selectedProfile={dialog.action}
                />
            )}
        </Box>
    );
}